// Generated by purs version 0.15.15
var parOneOf = function (dict) {
    return dict.parOneOf;
};
var getPerformanceStats = function (dict) {
    return dict.getPerformanceStats;
};
var getPerformanceMemory = function (dict) {
    return dict.getPerformanceMemory;
};
var getDeviceMemory = function (dict) {
    return dict.getDeviceMemory;
};
var fetchUploadProgress = function (dict) {
    return dict.fetchUploadProgress;
};
var fetchTcpStats = function (dict) {
    return dict.fetchTcpStats;
};
export {
    fetchTcpStats,
    fetchUploadProgress,
    parOneOf,
    getPerformanceStats,
    getPerformanceMemory,
    getDeviceMemory
};
